import React from 'react';
interface TextInputWidgetProps {
  question: string;
  placeholder?: string;
  optional?: boolean;
  onSubmit: (text: string) => void;
  onSkip?: () => void;
}
export function TextInputWidget({
  question,
  placeholder = 'Scrivi qui...',
  optional = false,
  onSubmit,
  onSkip
}: TextInputWidgetProps) {
  return <div className="mt-3 bg-white border border-yeppy-text border-opacity-15 rounded-2xl p-4" data-id="element-452">
      <p className="font-poppins text-sm font-medium mb-3" style={{
      color: '#1D2A36'
    }} data-id="element-453">
        {question}
        {optional && <span className="ml-2 text-xs text-yeppy-text text-opacity-50" data-id="element-454">
            (opzionale)
          </span>}
      </p>

      {optional && onSkip && <button onClick={onSkip} className="w-full px-4 py-2 rounded-full font-poppins text-sm text-yeppy-text text-opacity-60 transition-colors" data-id="element-455">
          Salta
        </button>}
    </div>;
}